import TiendanubeCvu from "./TiendanubeCvu"

const TiendanubeCvuBody = () => {
	return <TiendanubeCvu appId={process.env.REACT_APP_TIENDANUBE_CVU_APP_ID} />
}

export default TiendanubeCvuBody
